/**
 * Safely parse JSON string, returning fallback on error.
 */
export function safeParseJSON<T>(str: string, fallback: T): T {
  try {
    return JSON.parse(str) as T;
  } catch {
    return fallback;
  }
}
